// config/booking-restrictions.ts

type FlowType = 'Online' | 'In-person' | 'Assessment'

interface DateRestriction {
  startDate: string // ISO format: 'YYYY-MM-DD'
  endDate: string
  blockedFlows: FlowType[]
  doctorIds?: string[] // If provided, only applies to these doctors. If omitted, applies to all.
  reason?: string
}

export const bookingRestrictions: DateRestriction[] = [
  {
    startDate: '2026-01-08',
    endDate: '2026-01-16',
    blockedFlows: ['In-person'],
    doctorIds: ['1'], // Only Dr. Meena
    reason: 'Dr. Meena unavailable for in-person consultations',
  },
]

export function isFlowBlockedOnDate(
  flow: FlowType | null,
  date: Date,
  doctorId?: string,
): { blocked: boolean; reason?: string } {
  if (!flow) return { blocked: false }

  const dateStr = date.toISOString().split('T')[0]

  for (const restriction of bookingRestrictions) {
    // Check if date is in range
    if (dateStr < restriction.startDate || dateStr > restriction.endDate)
      continue

    // Check if flow is blocked
    if (!restriction.blockedFlows.includes(flow)) continue

    // Check if doctor-specific restriction applies
    if (restriction.doctorIds && restriction.doctorIds.length > 0) {
      // If doctorIds specified, only block if current doctor is in the list
      if (!doctorId || !restriction.doctorIds.includes(doctorId)) continue
    }

    return { blocked: true, reason: restriction.reason }
  }

  return { blocked: false }
}

export function getBlockedRangesForFlow(
  flow: FlowType | null,
  doctorId?: string,
): { startDate: string; endDate: string; reason?: string }[] {
  if (!flow) return []

  return bookingRestrictions
    .filter((r) => {
      if (!r.blockedFlows.includes(flow)) return false
      // If doctor-specific, check if it applies
      if (r.doctorIds && r.doctorIds.length > 0) {
        if (!doctorId || !r.doctorIds.includes(doctorId)) return false
      }
      return true
    })
    .map((r) => ({
      startDate: r.startDate,
      endDate: r.endDate,
      reason: r.reason,
    }))
}
